var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"none","flex-direction":"column"},attrs:{"id":"ccp-sidebar-level-2"}},[_c('p',{staticClass:"lead"}),_c('ul',{staticClass:"nav nav-pills nav-stacked"})])
}]

export { render, staticRenderFns }